import {
  index as baseIndex
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of alphalink_mobile_products based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('alphalink_mobile_product_groups', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all alphalink_mobile_product_groups to serve in a dropdown form choice
 */
export function fetchAlphalinkMobileProductGroups(search = []) {
  return baseIndex('alphalink_mobile_product_groups', 1, 0, search, 'ASC');
}
